export default "__VITE_ASSET__e410a88f__"